<template>
  <div class="navigation-bar">
    <router-link v-for="route in routes" v-bind:key="route.name" :to="{ path: route.path }">
      <md-button class="md-primary">
        {{ route.title }}
      </md-button>
    </router-link>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'NavigationBar',
  computed: {
    ...mapState('navigation', ['routes'])
  }
}
</script>

<style>
</style>
